var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { throttle, bind } from "lodash-decorators";
import { Key } from "ts-keycode-enum";
var AutoComplete = /** @class */ (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "autocomplete";
        _this.currentText = "";
        _this.showDropdown = false;
        _this.highlightedIndex = 0;
        _this.touched = false;
        return _this;
    }
    AutoComplete.prototype.created = function () {
        this.$parent.$on('reset', this.onReset);
    };
    AutoComplete.prototype.mounted = function () {
        this.currentText = this.defaultValue;
        this.setupBlurHandler();
        this.setupResize();
        this.onResize();
    };
    AutoComplete.prototype.onInput = function (e) {
        // Ignore IE11's click events
        if (!this.touched && e.target.value === '') {
            return;
        }
        this.touched = true;
        this.$emit('input', e);
    };
    AutoComplete.prototype.onFocus = function () {
        this.showDropdown = true;
    };
    AutoComplete.prototype.onChange = function (item) {
        if (item && item.title) {
            this.currentText = item.title;
        }
        this.showDropdown = false;
        return item;
    };
    AutoComplete.prototype.onResize = function () {
        var _this = this;
        if (!this.$refs.input) {
            return;
        }
        requestAnimationFrame(function () {
            var inputWidth = _this.$refs.input.offsetWidth;
            _this.$refs.inputResults.style.width = inputWidth + "px";
        });
    };
    AutoComplete.prototype.onBlur = function () {
        this.showDropdown = false;
    };
    AutoComplete.prototype.onKeyDown = function (e) {
        var maxHighlightedIndex = this.results.length - 1;
        if (this.results.length <= 0) {
            return;
        }
        switch (e.which) {
            case Key.UpArrow:
                if (this.highlightedIndex > 0) {
                    this.changeHighlighted(this.highlightedIndex - 1);
                }
                break;
            case Key.DownArrow:
                e.preventDefault();
                if (this.highlightedIndex < maxHighlightedIndex) {
                    this.changeHighlighted(this.highlightedIndex + 1);
                }
                break;
            case Key.Enter:
                if (this.showDropdown) {
                    e.preventDefault();
                    this.onChange(this.results[this.highlightedIndex]);
                }
                break;
            case Key.Escape:
                this.onBlur();
                break;
        }
    };
    AutoComplete.prototype.changeHighlighted = function (index) {
        var listElement = this.$refs.inputResults;
        var listElementStart = listElement.scrollTop;
        var listElementEnd = listElement.scrollTop + listElement.offsetHeight;
        // Note: The nth-child indexes starts at 1
        var selectedItemElement = listElement.querySelector("li:nth-child(".concat(index + 1, ")"));
        var selectedItemStart = selectedItemElement.offsetTop;
        var selectedItemEnd = selectedItemElement.offsetTop + selectedItemElement.offsetHeight;
        this.highlightedIndex = index;
        // Scroll up
        if (selectedItemStart < listElementStart) {
            listElement.scrollTo({ top: selectedItemStart });
        }
        // Scroll down
        if (selectedItemEnd > listElementEnd) {
            listElement.scrollTo({ top: selectedItemEnd - listElement.offsetHeight });
        }
    };
    AutoComplete.prototype.setupBlurHandler = function () {
        var _this = this;
        var autocompleteWrapper = this.$refs.wrapper;
        var blurHandler = function (e) {
            if (!autocompleteWrapper.contains(e.target)) {
                _this.onBlur();
            }
        };
        document.addEventListener('click', blurHandler);
        document.addEventListener('touchstart', blurHandler);
    };
    AutoComplete.prototype.setupResize = function () {
        window.addEventListener("resize", this.onResize);
    };
    AutoComplete.prototype.onReset = function () {
        this.currentText = this.defaultValue;
        this.showDropdown = false;
        this.highlightedIndex = 0;
        this.touched = false;
    };
    __decorate([
        Prop([String, Object])
    ], AutoComplete.prototype, "className", void 0);
    __decorate([
        Prop(String)
    ], AutoComplete.prototype, "ariaLabel", void 0);
    __decorate([
        Prop(String)
    ], AutoComplete.prototype, "placeholder", void 0);
    __decorate([
        Prop(String)
    ], AutoComplete.prototype, "inputName", void 0);
    __decorate([
        Prop({ type: Array, default: [] })
    ], AutoComplete.prototype, "results", void 0);
    __decorate([
        Prop({ type: String, default: "" })
    ], AutoComplete.prototype, "defaultValue", void 0);
    __decorate([
        Emit("change")
    ], AutoComplete.prototype, "onChange", null);
    __decorate([
        bind(this),
        throttle(50)
    ], AutoComplete.prototype, "onResize", null);
    AutoComplete = __decorate([
        Component
    ], AutoComplete);
    return AutoComplete;
}(Vue));
export default AutoComplete;
